import { atom } from "recoil";

export const staffDetailModalStore = atom({
	key: "staffDetailModalStore",
	default: {
		show: false,
		loaded: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		login: "",
		person: null,
		dirty: false,
		activeTabId: "overview",
		groups: [],
		groupsLoaded: false,
		groupsError: null,
		accessActionForm: { mode: "update", brands: [], level: "", password: "", groupIds: [], updateLevel: false, updateGroups: true, groupUpdateMode: "replace" },
		credentialsForm: {
			newLogin: "",
			password: "",
			passwordScope: "global",
			passwordBrands: [],
		},
		tfaReveal: null,
		pending: {
			accessAction: false,
			saveCredentials: false,
			changeLogin: false,
			changePassword: false,
			resetTfa: {},
			removeTfa: false,
			getTfa: false,
		},
	},
});
